import { AuthLayout } from '@/features/auth/components/AuthLayout';
import { EmailStep } from '@/features/auth/components/EmailStep';
import { TokenStep } from '@/features/auth/components/TokenStep';
import { useLoginFlow } from '@/features/auth/useLoginFlow';
import { useAuth } from '@/shared/auth/auth-context';
import { AlertIcon } from '@/shared/ui/icons';

/** Tela de login. Orquestra as duas etapas; a lógica está em `useLoginFlow`. */
export function LoginPage() {
  const { expirationNotice } = useAuth();
  const flow = useLoginFlow();

  return (
    <AuthLayout>
      {expirationNotice ? (
        <div role="status" className="mb-6 flex items-start gap-2.5 rounded-lg border border-pending/25 bg-pending-soft px-3.5 py-3 text-pending">
          <AlertIcon className="mt-px size-[1.125rem] shrink-0" />
          <p className="text-[0.8125rem] font-medium">{expirationNotice}</p>
        </div>
      ) : null}

      {flow.step === 'email' ? (
        <EmailStep submitting={flow.submitting} error={flow.error} onSubmit={flow.submitEmail} onChange={flow.clearError} />
      ) : (
        <TokenStep
          email={flow.email}
          submitting={flow.submitting}
          error={flow.error}
          onSubmit={flow.submitToken}
          onResend={flow.resendToken}
          onBack={flow.backToEmail}
          onChange={flow.clearError}
        />
      )}
    </AuthLayout>
  );
}
